import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { path: "/homepage", label: "Home" },
    { path: "/services", label: "Services" },
    { path: "/instant-it-quote", label: "IT Procurement" },
    { path: "/products", label: "Products" },
    { path: "/about", label: "About Us" },
    { path: "/growth", label: "Growth Hub" },
  ];



  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="header-container ">
        <div className="header-content">
          <div className="header-logo-container">
            <div className="header-logo">
              <img
                src="/assets/logo.png"
                alt="Orator Hype"
                className="w-[10rem] h-[5rem] object-contain"
              />
            </div>
          </div>

          <nav className="header-nav">
            {navigationItems.map((item) => {
              const isExternal = !!item.external;
              const key = item.path ?? item.external;

              return (
                <button
                  key={key}
                  onClick={() => {
                    if (isExternal) {
                      window.open(item.external, "_blank", "noopener,noreferrer");
                      setIsMobileMenuOpen(false);
                      return;
                    }
                    handleNavigation(item.path);
                  }}
                  className={`header-nav-link ${
                    isExternal
                      ? "ssm-nav-link"
                      : isActivePath(item.path)
                      ? "active"
                      : ""
                  } ${
                    isExternal
                      ? "text-amber-200 border border-red-500/60 bg-gradient-to-r from-red-500/10 via-amber-400/10 to-red-500/10"
                      : ""
                  }`}

                >
                  {item.label}
                </button>
              );
            })}

          </nav>

          {/* CIN & GSTIN (Desktop) */}
          <div className="header-actions hidden lg:flex flex-col items-end text-white text-xs leading-tight">
            <span>CIN: U73100MH2025PTC452599</span>
            <span>GSTIN: 27AAECO8036H1ZA</span>
          </div>
        </div>
      </header>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMobileMenu}
        className="mobile-menu-button"
        aria-label="Toggle mobile menu"
        aria-expanded={isMobileMenuOpen}
      >
        <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
      </button>

      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${!isMobileMenuOpen ? "closed" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      >
        <nav
          className="mobile-menu-content bg-transparent backdrop-blur-md p-6 rounded-2xl 
                     text-white flex flex-col h-full"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-hidden={!isMobileMenuOpen}
        >
          {/* Navigation Links */}
          <div className="flex flex-col gap-2">
            {navigationItems.map((item) => {
              const isExternal = !!item.external;
              const key = item.path ?? item.external;

              return (
                <button
                  key={key}
                  onClick={() => {
                    if (isExternal) {
                      window.open(item.external, "_blank", "noopener,noreferrer");
                      setIsMobileMenuOpen(false);
                      return;
                    }
                    handleNavigation(item.path);
                  }}
                  className={`mobile-menu-link text-white ${
                    isExternal
                      ? "text-amber-200 border border-red-500/60 bg-gradient-to-r from-red-500/10 via-amber-400/10 to-red-500/10"
                      : isActivePath(item.path)
                      ? "active"
                      : ""
                  }`}
                >
                  {item.label}
                </button>
              );
            })}

          </div>

          {/* Push company details to bottom */}
          <div className="mt-auto pt-6 text-xs text-white/80 leading-relaxed border-t border-white/20">
            <p>CIN: U73100MH2025PTC452599</p>
            <p>GSTIN: 27AAECO8036H1ZA</p>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
